import { useEffect, useState } from "react";
import { http, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import HomeHeader from "@/components/home/HomeHeader";
import AvailabilityGrid from "@/components/AvailabilityGrid";
import PerformanceCard from "@/components/home/PerformanceCard";
import LastMatchCard from "@/components/home/LastMatchCard";
import NextBestAction from "@/components/home/NextBestAction";
import QuickActions from "@/components/home/QuickActions";
import PlayersNearYou from "@/components/home/PlayersNearYou";
import PlayNearYou from "@/components/home/PlayNearYou";
import WeeklyPerformance from "@/components/home/WeeklyPerformance";
import WeeklyChallenge from "@/components/home/WeeklyChallenge";
import SocialStrip from "@/components/home/SocialStrip";
import UpcomingSchedule from "@/components/home/UpcomingSchedule";
import WhatsOn from "@/components/home/WhatsOn";

export default function Home() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let alive = true;
    http.get("/home").then((r) => alive && setData(r.data)).catch((e) => alive && setErr(formatError(e)));
    return () => { alive = false; };
  }, []);

  if (err) return <div className="py-20 text-center text-sm text-red-600" data-testid="home-error">{err}</div>;
  if (!data) return <div className="grid place-items-center py-24"><Loader2 className="animate-spin pv-text-dark" size={28} /></div>;

  return (
    <div className="max-w-2xl mx-auto space-y-6 pb-6" data-testid="home-screen">
      <HomeHeader data={data} />

      {/* What's On — community events discovery at the top */}
      <WhatsOn />

      {/* Scheduling-first core: when & where can I play */}
      <AvailabilityGrid />
      <PlayersNearYou players={data.players_near} availableNow={data.available_now} />
      <PlayNearYou sessions={data.play_near} />
      <NextBestAction nba={data.next_best_action} />
      <QuickActions />
      <UpcomingSchedule upcoming={data.upcoming} />

      {/* Secondary: your game / stats */}
      <div className="pt-2" data-testid="your-game-section">
        <div className="flex items-center gap-3 mb-3">
          <h2 className="text-xs font-black uppercase tracking-widest text-[#5C7285]">Your Game</h2>
          <div className="flex-1 h-px bg-[#0E395F]/10" />
        </div>
        <div className="space-y-4">
          <PerformanceCard perf={data.performance} />
          <LastMatchCard match={data.last_match} />
          <WeeklyPerformance weekly={data.weekly} />
          <WeeklyChallenge challenge={data.challenge} />
        </div>
      </div>

      <SocialStrip highlights={data.highlights} />
    </div>
  );
}
